import React from "react";
import i18n from "@i18n";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet";
import {
  breakpointDesktopOnly,
  breakpointMobileOnly,
} from "src/design-system/styles/breakpoints";
import { css } from "@emotion/react";
import { MainColumn } from "src/components/core/BodyLayout";
import {
  createForwardParams,
  updateForwardedParams,
} from "src/utils/urlParams";
import { LandingFooter } from "src/components/footer/LandingFooter";

const layoutStyles = css`
  @media ${breakpointMobileOnly} {
    height: 100%;
  }
`;

const Footer = styled.footer`
  margin-top: 60px;
`;

const Container = styled.div`
  @media ${breakpointMobileOnly} {
    height: 100%;
  }

  @media ${breakpointDesktopOnly} {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
  }
`;

export function personalityQuizURL(args?: { persona?: string }) {
  const url = new URL(window.location.href);
  updateForwardedParams({ s: null });
  url.search = createForwardParams().toString();
  url.pathname = "/f/personality-quiz/";
  if (args?.persona != null) {
    url.pathname += `persona-${args.persona}`;
  }
  return url.href;
}

export default function Layout({ children, showFooter = true }) {
  return (
    <Container>
      <Helmet>
        <title>{i18n.t("freeProductsPersonalityQuiz:title")}</title>
      </Helmet>
      <MainColumn css={layoutStyles} maxWidth={580}>
        {children}
      </MainColumn>
      {showFooter ? (
        <Footer>
          <LandingFooter />
        </Footer>
      ) : null}
    </Container>
  );
}
